import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { hoursDecimalToHM } from "src/utils";

const colors = ["#0075FF", "#16AA75", "#A155B9", "#CC9C33"];

const AvgStayLinearChart = ({
  data,
}: {
  data: {
    avgParkingHours: number;
    date: string;
  }[];
}) => {
  const theme = useTheme();
  const matchesMediumUp = useMediaQuery(theme.breakpoints.up("md"));

  const xAxisLabels: any = [];
  const valuesArr: any = [];

  data?.forEach((item) => {
    xAxisLabels.push(item.date);
    valuesArr.push((item.avgParkingHours).toFixed(1));
  });

  const series = [
    {
      name: "Avg Stay Time",
      data: valuesArr,
    },
  ];

  const options: ApexCharts.ApexOptions = {
    theme: {
      mode: "dark",
    },
    colors: colors,
    noData: {
      text: "No data available ",
      style: {
        fontSize: "15px",
      },
    },
    chart: {
      redrawOnParentResize: true,
      toolbar: {
        show: false, // Hide the download icons
      },
      type: "line",
      zoom: {
        enabled: false,
      },
      foreColor: "#f0f0f0",
      background: "#242424",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
      width: 2.5,
    },
    markers: {
      size: 3, // Adjust the size of the marker
      shape: "circle",
      strokeColors: colors,
    },
    xaxis: {
      labels: {
        show: false,
      },
      categories: xAxisLabels,
    },
    tooltip: {
      y: {
        formatter: (value: number): string => hoursDecimalToHM(+value)?.toString(),
      },
    },
    yaxis: {
      labels: {
        formatter: hoursDecimalToHM,
      },
    },
    grid: {
      borderColor: "#000",
      show: true,
    },
    legend: {
      show: true,
      fontSize: "13.3px",
      itemMargin: {
        horizontal: matchesMediumUp ? 15 : 5,
        vertical: 5,
      },
      markers: {
        width: 8,
        height: 8,
        strokeWidth: 0,
        radius: 0,
      },
    },
  };

  return (
    <Box
      bgcolor={"#242424"}
      overflow={"hidden"}
      pb={"10px"}
      borderRadius={"12px"}
    >
      <Box bgcolor={"#242424"} padding={"21px 24px"}>
        <Typography fontWeight={700} fontSize={"20px"}>
          Average Stay Time
        </Typography>
      </Box>
      <Box bgcolor={"#000000"} height={"2px"} />
      <ReactApexChart
        series={series}
        options={options}
        height={300}
        type="line"
        width={"100%"}
      />
    </Box>
  );
};

export default AvgStayLinearChart;
